/* COOODEX Partner-Gate — zentrale Gating-Logik (B2B Option A)
 *
 * Zustaende:
 *   'guest'   — nicht eingeloggt:        Preise/Bestellformulare verborgen, CTA "Als Fachpartner registrieren"
 *   'pending' — eingeloggt ohne Tag:     Hinweis "Ihr Zugang wird geprueft …"
 *   'partner' — eingeloggt + Tag partner: Preise nachladen + Bestellformulare aktivieren
 *
 * Markup-Konventionen:
 *   [data-gate-show="guest|pending|partner|auth"] — Sichtbarkeit je Zustand ('auth' = pending ODER partner).
 *     Konvention: guest-Elemente sind im HTML sichtbar (Default ohne JS), alle anderen tragen `hidden`.
 *   [data-gated-price][data-variant-id="…"]       — Preis-Slot, wird NUR im Zustand 'partner' befuellt.
 *   form[data-gated-form][hidden]                  — /cart/add-Formular, wird NUR im Zustand 'partner' aktiviert.
 *   [data-partner-orders]                          — echte Bestellzahl (numberOfOrders) fuer Eingeloggte.
 *   [data-partner-api-logout]                      — Abmelden: Token entfernen + Redirect /pages/partnerkonto.
 *
 * Event: document feuert 'cooodex:gate' mit detail { state, customer } sobald der Zustand feststeht.
 */
(function () {
  'use strict';
  if (window.CooodexGate) return; // Doppel-Einbindung (mehrere Sections) abfangen

  var CONFIG = window.COODEX_PARTNER_AUTH || {
    endpoint: 'https://cooodex-partner.de/api/2025-10/graphql.json',
    token: 'c3984fffa25a88abb864400176eab6c1',
    storageKey: 'cooodex_customer_access'
  };
  var PRODUCT_JSON_URL = '/products/cooodex-b2b-grosshandel.js';
  var LOGIN_URL = '/pages/partnerkonto';
  var PARTNER_TAG = 'partner';

  var Gate = {
    state: 'guest',
    customer: null,
    resolved: false
  };
  window.CooodexGate = Gate;

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function readToken() {
    try {
      var data = JSON.parse(localStorage.getItem(CONFIG.storageKey) || 'null');
      if (!data || !data.accessToken) return null;
      if (data.expiresAt && new Date(data.expiresAt) <= new Date()) return null;
      return data.accessToken;
    } catch (e) {
      return null;
    }
  }

  /* Preisformat: 47760 (Cent) -> "477,60 €" */
  function formatMoney(cents) {
    var value = cents / 100;
    try {
      return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    } catch (e) {
      var fixed = value.toFixed(2).replace('.', ',');
      return fixed.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
  }

  function isVisibleInState(spec, state) {
    var wanted = String(spec || '').split(/\s+/);
    for (var i = 0; i < wanted.length; i++) {
      if (wanted[i] === state) return true;
      if (wanted[i] === 'auth' && state !== 'guest') return true;
    }
    return false;
  }

  function applyVisibility() {
    each(document.querySelectorAll('[data-gate-show]'), function (node) {
      var visible = isVisibleInState(node.getAttribute('data-gate-show'), Gate.state);
      node.hidden = !visible;
      node.style.display = visible ? '' : 'none';
    });
  }

  function updateOrders(customer) {
    var count = customer && customer.numberOfOrders != null ? String(customer.numberOfOrders) : '0';
    each(document.querySelectorAll('[data-partner-orders]'), function (node) {
      node.textContent = count;
    });
  }

  /* Zustand (c): Preise via Shopify-Produkt-JSON nachladen und Slots fuellen,
     anschliessend /cart/add-Formulare aktivieren. */
  function unlockPricesAndForms() {
    fetch(PRODUCT_JSON_URL, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (product) {
        var priceById = {};
        each((product && product.variants) || [], function (variant) {
          priceById[String(variant.id)] = variant.price;
        });

        each(document.querySelectorAll('[data-gated-price]'), function (slot) {
          var id = slot.getAttribute('data-variant-id');
          if (id == null || priceById[id] == null) return;
          slot.classList.add('is-unlocked');
          // z. B. "477,60 € netto zzgl. MwSt." — sicher per DOM-Knoten aufgebaut
          slot.textContent = '';
          var value = document.createElement('span');
          value.className = 'gated-price-value';
          value.textContent = formatMoney(priceById[id]);
          var sub = document.createElement('span');
          sub.className = 'gated-price-sub';
          sub.textContent = 'netto zzgl. MwSt.';
          slot.appendChild(value);
          slot.appendChild(document.createTextNode(' '));
          slot.appendChild(sub);
        });

        each(document.querySelectorAll('form[data-gated-form]'), function (form) {
          form.removeAttribute('hidden');
          form.hidden = false;
          each(form.querySelectorAll('button, input[type="submit"]'), function (button) {
            button.disabled = false;
          });
        });
      })
      .catch(function () { /* Slots behalten "Preis nach Freischaltung" */ });
  }

  function dispatchState() {
    var detail = { state: Gate.state, customer: Gate.customer };
    var event;
    try {
      event = new CustomEvent('cooodex:gate', { detail: detail });
    } catch (e) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('cooodex:gate', false, false, detail);
    }
    document.dispatchEvent(event);
  }

  function resolve(state, customer) {
    Gate.state = state;
    Gate.customer = customer;
    Gate.resolved = true;
    applyVisibility();
    if (state !== 'guest') updateOrders(customer);
    if (state === 'partner') unlockPricesAndForms();
    dispatchState();
  }

  function fetchCustomer(token) {
    return fetch(CONFIG.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.token
      },
      body: JSON.stringify({
        query: 'query Gate($t: String!) { customer(customerAccessToken: $t) { firstName lastName email tags numberOfOrders } }',
        variables: { t: token }
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        return (result && result.data && result.data.customer) || null;
      });
  }

  function writeToken(tokenObj) {
    try {
      if (tokenObj && tokenObj.accessToken) {
        localStorage.setItem(CONFIG.storageKey, JSON.stringify(tokenObj));
      }
    } catch (e) {}
  }

  /* Session verlaengern: bei jedem Besuch den Storefront-Token erneuern, damit
     eingeloggte Partner eingeloggt bleiben — einmal anmelden genuegt. Erneuerung
     funktioniert nur solange der bestehende Token noch nicht abgelaufen ist. */
  function renewToken(token) {
    fetch(CONFIG.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CONFIG.token
      },
      body: JSON.stringify({
        query: 'mutation Renew($t: String!) { customerAccessTokenRenew(customerAccessToken: $t) { customerAccessToken { accessToken expiresAt } userErrors { message } } }',
        variables: { t: token }
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (result) {
        var payload = result && result.data && result.data.customerAccessTokenRenew;
        var renewed = payload && payload.customerAccessToken;
        if (renewed && renewed.accessToken) writeToken(renewed);
      })
      .catch(function () { /* Erneuerung fehlgeschlagen -> bestehender Token gilt bis expiresAt */ });
  }

  /* Abmelden (delegiert, funktioniert auch fuer spaeter eingefuegte Links) */
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-partner-api-logout]') : null;
    if (!target) return;
    event.preventDefault();
    try { localStorage.removeItem(CONFIG.storageKey); } catch (e) {}
    window.location.href = LOGIN_URL;
  });

  var token = readToken();
  if (!token) {
    resolve('guest', null);
  } else {
    fetchCustomer(token)
      .then(function (customer) {
        if (!customer) {
          // Token ungueltig/abgelaufen -> aufraeumen, Gast-Zustand
          try { localStorage.removeItem(CONFIG.storageKey); } catch (e) {}
          resolve('guest', null);
          return;
        }
        var tags = customer.tags || [];
        var isPartner = false;
        for (var i = 0; i < tags.length; i++) {
          var t = String(tags[i]).trim().toLowerCase();
          if (t === PARTNER_TAG || t === 'b2b-partner') { isPartner = true; break; }
        }
        resolve(isPartner ? 'partner' : 'pending', customer);
        // Session bei jedem Besuch verlaengern -> Partner bleibt eingeloggt
        renewToken(token);
      })
      .catch(function () {
        resolve('guest', null);
      });
  }
})();